import { render } from "./ContactsPeopleList.vue?vue&type=template&id=36e18674"
import script from "./ContactsPeopleList.vue?vue&type=script&lang=js"
export * from "./ContactsPeopleList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__